import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { IconButtonProps as MuiIconButtonProps } from "@mui/material";
import { IconButton } from "..";

export const UpdateIconButton = (
  props: MuiIconButtonProps & {
    onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  }
) => {
  const { onClick, ...rest } = props;

  return (
    <IconButton onClick={onClick} color="primary" size="small" {...rest}>
      <EditOutlinedIcon />
    </IconButton>
  );
};
